export const cta = {
    signIn: 'Sign in with Google',
    continue: 'continue',
    logout: 'logout',
    post: 'post',
    posts: 'posts',
    favorites: 'favorites',
    home: 'return to Home'
}